import React, { PureComponent } from 'react'
import { Grid, Paper, Table, TableCell, TableBody, TableHead, TableRow } from '@material-ui/core'

import { WebhookTypesArray } from '../../utils/constants'
import { hasAccess } from '../../utils/api'

import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import WebHookItem from './WebHookItem'

const WebHookItemEditable = EditableHOCWrapper(WebHookItem)

class ShopWebHookList extends PureComponent {
  render() {
    const { shop, webHooks, lastModified } = this.props
    //console.log(webHooks, "webHooks");
    return (
      <div>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <h1 className="margin-left-small">{shop.name}</h1>
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Webhook Type</TableCell>
                      <TableCell>URL</TableCell>
                      {hasAccess() ? <TableCell></TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {WebhookTypesArray.map((webHook) => {
                      return (
                        <WebHookItemEditable
                          key={webHook.value}
                          dataToEdit={webHooks[webHook.value]}
                          lastModified={lastModified}
                          label={webHook.label}
                          onSave={this.props.onSave}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default ShopWebHookList

ShopWebHookList.defaultProps = {
  shop: {},
}



// WEBPACK FOOTER //
// ./src/components/WebHooks/ShopWebHookList.js